export const ChartErrorComp = ({ errorMessage }) => {
  return (
    <div className="flex w-full h-full">
      <div className="flex w-full flex-col gap-4 items-center justify-center p-8">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
          <p className="text-lg font-semibold text-red-900 mb-2">Chart Error</p>
          <p className="text-red-600 font-medium">{errorMessage}</p>
        </div>
      </div>
    </div>
  );
};
